import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { toAbsoluteUrl } from '../../../../_metronic/_helpers'
import { userRegistrationAsync, ipAsync } from '../_redux'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import './body.scss'

const initialValues = {
  emailId: '',
  contactNumber: '',
  password: '',
  confirmPassword: '',
  showField: 'email',
  // countryCode: '+91',
}

const phoneRegExp = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/

const addBodyClass = (className) =>
  document.body.classList.add('removeHeaderFooter')
const removeBodyClass = (className) =>
  document.body.classList.remove('removeHeaderFooter')

const registerSchema = Yup.object().shape({
  emailId: Yup.string()
    .trim()
    .when('showField', {
      is: 'email',
      then: Yup.string()
        .email('Please enter valid email address')
        .required('Please enter a email'),
    }),
  contactNumber: Yup.string()
    .trim()
    .when('showField', {
      is: 'phone',
      then: Yup.string()
        .min(10, 'Please enter valid phone number')
        .required('Please enter a phone number'),
    }),
  password: Yup.string()
    .trim()
    .required('Please enter password')
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{6,}$/,
      'Password must Contain at least 6 Characters, One Uppercase, One Lowercase, One Number and one special case Character from the followings: [ @$!%*#?& ]',
    ),
  confirmPassword: Yup.string()
    .trim()
    .test(
      'passwords-match',
      "Password and confirm password didn't matched",
      function (value) {
        return this.parent.password === value
      },
    ),
})

function Register(props) {
  useEffect(() => {
    // Set up
    props.className instanceof Array
      ? props.className.map(addBodyClass)
      : addBodyClass('removeHeaderFooter')

    // Clean up
    return () => {
      props.ArrayclassName instanceof Array
        ? props.className.map(removeBodyClass)
        : removeBodyClass('removeHeaderFooter')
    }
  }, [props.className])

  //password show hide
  const [passwordShown, setPasswordShown] = useState(false)
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true)
  }

  const [passwordShown_v2, setPasswordShown_v2] = useState(false)
  const togglePasswordVisiblity_v2 = () => {
    setPasswordShown_v2(passwordShown_v2 ? false : true)
  }

  const [countryCode, setCountryCode] = useState({ country: '', code: '' })

  useEffect(() => {
    // ipAsync().then(data => {
    // 	setCountryCode({ country: data.gec.toLowerCase(), code: "+" + data.country_code })
    // });
    setCountryCode({ country: 'us', code: '+' + 1 })
  }, [])

  const { redirectRegisterVerification, isLoading, flashMessage } = useSelector(
    (state) => state.auth,
    shallowEqual,
  )

  const dispatch = useDispatch()

  const phoneRef = useRef()
  const emailRef = useRef()

  const formik = useFormik({
    initialValues,
    validationSchema: registerSchema,
    onSubmit: (values) => {
      let user = {
        password: values.password,
      }
      if (values.showField === 'email') {
        user.emailId = values.emailId
      }
      if (values.showField === 'phone') {
        user.contactNumber = values.contactNumber
      }
      dispatch(userRegistrationAsync(user))
    },
  })

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return 'is-invalid'
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return 'is-valid'
    }

    return ''
  }

  useEffect(() => {
    let showField = formik.values.showField
    if (showField === 'email' && emailRef.current) {
      emailRef.current.focus()
    }
    if (showField === 'phone' && phoneRef.current) {
      phoneRef.current.numberInputRef.focus()
    }
  }, [formik.values.showField])

  if (redirectRegisterVerification) {
    return <Redirect to="/register-verification" />
  }

  return (
    <>
      <div className="inner_main">
        <div className="row w-100">
          <div className="col-xl-3 d-flex align-items-end justify-content-center d_none_1199">
            <div>
              <img
                alt=""
                className="img-fluid"
                src={toAbsoluteUrl('/media/others/developer-outline.png')}
              />
            </div>
          </div>
          <div className="col-xl-6">
            <div className="row">
              <div className="col-md-12 text-center mt-15 mb-10">
                <img
                  alt="Logo"
                  className="max-h-70px mb-5"
                  src={toAbsoluteUrl('/media/logos/auth_logo.png')}
                />
              </div>
              {flashMessage ? (
                <div
                  className="mb-10 alert alert-custom alert-light-danger alert-dismissible"
                  style={{ margin: 'auto' }}
                >
                  <div className="alert-text font-weight-bold">
                    {flashMessage}
                  </div>
                </div>
              ) : null}
              <div className="col-md-12">
                <div className="wt_box mb-5">
                  <div
                    className="login-form login-signin"
                    id="kt_login_signin_form"
                  >
                    {/* begin::Head */}
                    <div className="text-center mb-10 mb-lg-15">
                      <h3 className="fn_s_32 color_blk f-w-500 mt-3">
                        Register Yourself
                      </h3>
                      <p className="opacity60 fn_s_16 color_blk f-w-400">
                        Welcome! Please enter your details to register.
                      </p>
                    </div>
                    {/* end::Head */}

                    {/*begin::Form*/}
                    <form
                      onSubmit={formik.handleSubmit}
                      className="form def_form text-left"
                    >
                      <div className="form-group">
                        <div className="d-flex justify-content-between">
                          <label className="form-label">
                            {formik.values.showField === 'email'
                              ? 'Email'
                              : 'Phone'}
                          </label>
                          <label
                            className="form-label dynamic_email_phone_label"
                            onClick={() =>
                              formik.setFieldValue(
                                'showField',
                                formik.values.showField === 'email'
                                  ? 'phone'
                                  : 'email',
                              )
                            }
                          >
                            Register with{' '}
                            {formik.values.showField === 'email'
                              ? 'Phone'
                              : 'Email'}
                          </label>
                        </div>

                        {/* Email Input */}
                        {formik.values.showField === 'email' && (
                          <input
                            placeholder="Email"
                            type="text"
                            className={`form-control ${getInputClasses(
                              'emailId',
                            )} password-valid`}
                            name="emailId"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.emailId}
                            ref={emailRef}
                          />
                        )}
                        {formik.values.showField === 'phone' && (
                          <PhoneInput
                            inputProps={{
                              name: 'contactNumber',
                            }}
                            countryCodeEditable={false}
                            placeholder="Phone"
                            country={countryCode.country}
                            value={formik.values.contactNumber}
                            inputClass="dynamic_phoneInput"
                            buttonClass="dynamic_countryDrop"
                            onChange={(phone, data, event) => {
                              formik.setFieldValue('contactNumber', phone)
                            }}
                            ref={phoneRef}
                          />
                        )}
                        {formik.values.showField === 'email' &&
                        formik.touched.emailId &&
                        formik.errors.emailId ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {formik.errors.emailId}
                            </div>
                          </div>
                        ) : null}

                        {formik.values.showField === 'phone' &&
                        formik.touched.contactNumber &&
                        formik.errors.contactNumber ? (
                          <div className="fv-plugins-message-container">
                            <div className="fv-help-block">
                              {formik.errors.contactNumber}
                            </div>
                          </div>
                        ) : null}
                      </div>
                      <div className="form-group">
                        <label className="form-label">Password</label>
                        <div className="frpsswrd">
                          <input
                            placeholder="Password"
                            type={passwordShown ? 'text' : 'password'}
                            className={`form-control ${getInputClasses(
                              'password',
                            )} password-valid`}
                            name="password"
                            {...formik.getFieldProps('password')}
                          />
                          <i
                            onClick={togglePasswordVisiblity}
                            className="far fa-eye-slash"
                          ></i>
                          {formik.touched.password && formik.errors.password ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {formik.errors.password}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>
                      <div className="form-group">
                        <label className="form-label">Confirm Password</label>
                        <div className="frpsswrd">
                          <input
                            placeholder="Password"
                            type={passwordShown_v2 ? 'text' : 'password'}
                            className={`form-control ${getInputClasses(
                              'confirmPassword',
                            )} password-valid`}
                            name="confirmPassword"
                            {...formik.getFieldProps('confirmPassword')}
                          />
                          <i
                            onClick={togglePasswordVisiblity_v2}
                            className="far fa-eye-slash"
                          ></i>
                          {formik.touched.confirmPassword &&
                          formik.errors.confirmPassword ? (
                            <div className="fv-plugins-message-container">
                              <div className="fv-help-block">
                                {formik.errors.confirmPassword}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="form-group mb-0 mt-0">
                        <div className="row">
                          <div className="col-md-12 text-center mb-0">
                            <button
                              disabled={isLoading}
                              className={`btn btn-def ${
                                !isLoading ? 'defwtarw' : ''
                              }`}
                            >
                              <span>Continue</span>
                              {isLoading && (
                                <span className="ml-3 spinner spinner-white"></span>
                              )}
                            </button>
                            {/* to="/register-verification" */}
                          </div>
                        </div>
                      </div>
                    </form>
                    {/*end::Form*/}
                  </div>
                </div>
              </div>
              <div className="col-md-12 text-center mt-3 bottom_links">
                <p className="fn_s_16 color_blk f-w-400 mt-2 mb-10">
                  <span className="opacity50">
                    Already have an account? &nbsp;
                  </span>
                  <Link to="/login" className="fn_s_16 color_blue f-w-400">
                    Login Now
                  </Link>
                </p>
                <Link
                  to="/"
                  className="bckbtn fn_s_14 color_blk f-w-500 opacity50 uppercase"
                >
                  Back To Home
                </Link>
              </div>
            </div>
          </div>

          <div className="col-xl-3 d_none_1199">
            <img
              alt=""
              className="img-fluid mt-20"
              src={toAbsoluteUrl('/media/others/support-solid.png')}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default Register
